import { Injectable } from "@angular/core";
import { AccountUserDTO } from "../accounts/AccountUser";
import { UserChangePasswordDTO, UserDTO } from "../auth/User";
import { AccountUsersHandlerService } from "../handlers/account-users-handler.service";
import { UsersHandlerService } from "../handlers/users-handler.service";

@Injectable({
  providedIn: "root",
})
export class UsersService {
  constructor(
    private usersHandlerService: UsersHandlerService,
    private accountUserHandlerService: AccountUsersHandlerService,
  ) {}

  updateUser(masterAccountID: number, userDTO: UserDTO) {
    return this.usersHandlerService.userPut(masterAccountID, userDTO);
  }

  createUser(masterAccountID: number, userDTO: UserDTO) {
    return this.usersHandlerService.userPost(masterAccountID, userDTO);
  }

  changePassword(
    masterAccountID: number,
    userChangePasswordDTO: UserChangePasswordDTO,
    userDTO: UserDTO,
  ) {
    return this.usersHandlerService.changePassword(
      masterAccountID,
      userChangePasswordDTO,
      userDTO,
    );
  }

  getUsers(
    masterAccountID: number,

    queryParams?: {
      page?: number;
      perPage?: number;
      ignoreSuper?: boolean;
      unassigned?: boolean;
    },
  ) {
    return this.usersHandlerService.usersGet(masterAccountID, queryParams);
  }

  getUser(masterAccountID: number, userID: number) {
    return this.usersHandlerService.userGet(masterAccountID, userID);
  }

  activateUser(masterAccountID: number, userID: number) {
    return this.usersHandlerService.activateUser(masterAccountID, userID);
  }

  deleteUser(masterAccountID: number, userDTO: UserDTO) {
    return this.usersHandlerService.userDelete(masterAccountID, userDTO);
  }

  getAccountUsers(masterAccountID: number) {
    return this.accountUserHandlerService.getAccountUsers(masterAccountID);
  }

  updateAccountUser(
    masterAccountID: number,
    userID: number,
    accountUserDTO: AccountUserDTO,
  ) {
    return this.accountUserHandlerService.putAccountUser(
      masterAccountID,
      userID,
      accountUserDTO,
    );
  }

  createAccountUser(masterAccountID: number, accountUserDTO: AccountUserDTO) {
    return this.accountUserHandlerService.postAccountUser(
      masterAccountID,
      accountUserDTO,
    );
  }

  deleteAccountUser(masterAccountID: number, accountUserID: number) {
    return this.accountUserHandlerService.deleteAccountUser(
      masterAccountID,
      accountUserID,
    );
  }
}
